/**
 * List of available simulation circuits.
 */
export const circuits: string[] = [
  'Systems Finals Prize Round',
  'Systems Finals Preliminary Round 1',
  'Systems Finals Preliminary Round 2',
  'Finals Prize Round World 1',
  'Finals Prize Round World 2',
  'Finals Prize Round World 3',
  'Finals Prize Round World 4',
  'Finals Prize Round World 5',
  'Finals Prize Round World 6',
  'Finals Prize Round World 7',
  'Finals Prize Round World 8',
  'Finals Preliminary Round World 1',
  'Finals Preliminary Round World 2',
  'Finals Preliminary Round World 3',
  'Finals Qualification',
  'Finals Practice 1',
  'Finals Practice 2',
  'Finals Practice 3',
  'Cave Circuit World 1',
  'Cave Circuit World 2',
  'Cave Circuit World 3',
  'Cave Circuit World 4',
  'Cave Circuit World 5',
  'Cave Circuit World 6',
  'Cave Circuit World 7',
  'Cave Circuit World 8',
  'Cave Qualification',
  'Cave Practice 1',
  'Cave Practice 2',
  'Cave Practice 3',
  'Cave Simple 1',
  'Cave Simple 2',
  'Cave Simple 3',
  'Urban Circuit World 1',
  'Urban Circuit World 2',
  'Urban Circuit World 3',
  'Urban Circuit World 4',
  'Urban Circuit World 5',
  'Urban Circuit World 6',
  'Urban Circuit World 7',
  'Urban Circuit World 8',
  'Urban Simple 1',
  'Urban Simple 2',
  'Urban Simple 3',
  'Urban Practice 1',
  'Urban Practice 2',
  'Urban Practice 3',
  'Urban Qualification',
  'NIOSH SR Config A',
  'NIOSH SR Config B',
  'NIOSH EX Config A',
  'NIOSH EX Config B',
  'Tunnel Circuit World 1',
  'Tunnel Circuit World 2',
  'Tunnel Circuit World 3',
  'Tunnel Circuit World 4',
  'Tunnel Circuit World 5',
  'Simple Tunnel 3',
  'Simple Tunnel 2',
  'Simple Tunnel 1',
  'Tunnel Practice 1',
  'Tunnel Practice 2',
  'Tunnel Practice 3',
  'Virtual Stix',
];
